import { BoxProps, Center, Spinner } from '@chakra-ui/react';
import React, { PropsWithChildren, Suspense } from 'react';

interface SuspenseHandlerProps {
  spinnerColor?: 'white' | 'black';
  loaderHeight?: BoxProps['height'];
}

export default function SuspenseHandler({
  children,
  spinnerColor = 'black',
  loaderHeight = 200
}: PropsWithChildren<SuspenseHandlerProps>) {
  return (
    <Suspense
      fallback={
        <Center width="full" height={loaderHeight}>
          <Spinner color={spinnerColor} />
        </Center>
      }
    >
      {children}
    </Suspense>
  );
}
